void 0 !== window.csapps &&
  void 0 === window.csapps.js_upsell_loaded &&
  ((window.csapps.js_upsell_loaded = !0),
  (window.csapps.upsell_request_ajax = "ToCancelPrevReq"),
  (window.csapps.pointer_p_s = ""),
  (window.csapps.pointer_n_s = ""),
  (window.csappsStartup_popup = function (s, e, t, o, a, i) {
    var l = window.csapps.settings["upsell-popup"],
      d = l.setting.discount_code_settings,
      n = window.csapps.settings.general.setting.upsell,
      p = l.setting.bogo_settings,
      c = window.csapps.settings["cart-drawer"],
      r =
        void 0 !== c && null != c && "" != c
          ? c.setting.cart_drawer
          : "undefined",
      _ = void 0 !== r && "null" != r && "" != r ? r.drawer_on_off : "disable";
    (window.csapps.offer_icon =
      '<svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 24 24" style="fill: ' +
      n.upsell_icon_text_color +
      ';"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></svg>'),
      s("body").on("click", ".upsell_loadmore", function (e) {
        e.preventDefault(),
          s(this).attr("disabled", "disabled").addClass("loading");
        var t = s(this).attr("data-next_url");
        aiod_upsell_reload(t);
      }),
      s("body").on("click", ".aiod_discount_code", function (e) {
        e.preventDefault();
        var t = s(this);
        if (
          (t.attr("disabled", "disabled"), window.csapps.cart.items.length > 0)
        ) {
          var o = t.attr("data-value");
          if (void 0 !== o && null != o && "" != o)
            (o = o.trim().toUpperCase()),
              -1 == window.csapps.csapp_discount_code.split(",").indexOf(o) &&
                ((window.csapps.csapp_discount_code =
                  "" == window.csapps.csapp_discount_code
                    ? o
                    : o + "," + window.csapps.csapp_discount_code),
                csapps.set_local_data(
                  "aiod_codes_" + window.csapps.store_id,
                  window.csapps.csapp_discount_code
                ),
                "undefined" != typeof aiod_bundle_addtocart_success
                  ? (aiod_bundle_addtocart_success(),
                    t.removeAttr("disabled", "disabled").removeClass("loading"))
                  : "enable" == _
                  ? fire_cart_data(1, "all", 0, t)
                  : (window.location = window.csapps.aiod_root_url + "/cart"));
        } else {
          var a = t.closest(".up_aiodcode_wrpr");
          a.addClass("in_error"),
            void 0 !== d.code_error_text &&
            null != d.code_error_text &&
            "" != d.code_error_text
              ? s("<p class='code_error'>" + d.code_error_text + "</p>")
                  .appendTo(a)
                  .delay(5e3)
                  .queue(function () {
                    a.removeClass("in_error"),
                      s(this).remove(),
                      t.removeAttr("disabled", "disabled");
                  })
              : setTimeout(function () {
                  a.removeClass("in_error"),
                    t.removeAttr("disabled", "disabled");
                }, 5e3);
        }
      }),
      s("body").on("click", ".upsell_free_g_add", function (e) {
        if (
          (e.preventDefault(),
          s(".csapp_fg_error").remove(),
          s(this)
            .closest(".offer-grid")
            .find(".csapps-freeg-thumb.active.not_available").length)
        )
          s(this).before(
            '<p class="csapp_fg_error cscode_msg">Any selected item is soldout, Please select another item.</p>'
          );
        else if (
          s(this).closest(".offer-grid").find(".csapps-freeg-thumb.active")
            .length
        ) {
          var t = s(this),
            o = [];
          t.attr("disabled", "disabled").addClass("loading"),
            t
              .closest(".offer-grid")
              .find(
                '.csapps-freeg-thumb.active:not(.not_available) select.free_p_grid_select[name="id"]'
              )
              .each(function (e, t) {
                var a = {};
                (a.id = s(t).val()), (a.quantity = 1), o.push(a);
              }),
            s
              .post(
                window.csapps.aiod_root_url + "/cart/add.js?csapp=aiod",
                { items: o },
                function (s) {
                  "undefined" != typeof aiod_bundle_addtocart_success
                    ? (aiod_bundle_addtocart_success(),
                      t
                        .removeAttr("disabled", "disabled")
                        .removeClass("loading"))
                    : "enable" == _
                    ? fire_cart_data(1, "all", 1, t)
                    : (window.location = window.csapps.aiod_root_url + "/cart");
                },
                "JSON"
              )
              .fail(function (s) {
                (window.location = window.csapps.aiod_root_url + "/cart"),
                  t.removeAttr("disabled", "disabled").removeClass("loading");
              });
        } else if (void 0 !== l && null != l && "" != l) {
          var a = l.setting.free_gift_settings.selection_error_message;
          void 0 !== a &&
            null != a &&
            "" != a &&
            s(this).before(
              '<p class="csapp_fg_error cscode_msg">' + a + "</p>"
            );
        }
      }),
      s("body").on("click", ".cs_upsell_pop_close", function (e) {
        e.preventDefault(), s(".aiod_upsell_aiodp, [data-aiod_ufp]").remove();
      }),
      s("body").on(
        "click",
        '.aiod-special-bonus-aiodp .aiod_free_get_wrpr[ data-atc="true"] .csapps-freeg-thumb',
        function (e) {
          e.preventDefault(),
            s(this).closest(".offer-grid").find(".csapp_fg_error").remove();
          var t = s(this).closest(".offer-grid-row").attr("data-max_gift"),
            o = s(this)
              .closest(".offer-grid-row")
              .find(".csapps-freeg-thumb.active").length;
          if (
            void 0 !== e.target.classList.value &&
            null != e.target.classList.value
          ) {
            if (e.target.classList.value.indexOf("free_p_grid_select") > -1)
              return;
            s(this).hasClass("active")
              ? s(this).removeClass("active")
              : o < t && s(this).addClass("active");
          }
        }
      );
    var u = csapps.get_local_data("aiod_upsell_opener_pos"),
      f = "",
      v = "show_add_to_cart" == n.upsell_free_gift_options,
      g = n.upsell_icon_position;
    if (null != u)
      (f += "left:" + (u = u.split(","))[0] + "px;"),
        (f += "top:" + u[1] + "px;");
    else
      switch (g) {
        case "bottom_right":
        default:
          (f += "right:20px;"), (f += "bottom:20px;");
          break;
        case "bottom_left":
          (f += "left:20px;"), (f += "bottom:20px;");
          break;
        case "center_left":
          (f += "left:20px;"),
            (f += "top:50%;"),
            (f += "transform:translateY(-50%);");
          break;
        case "center_right":
          (f += "right:20px;"),
            (f += "top:50%;"),
            (f += "transform:translateY(-50%);");
          break;
        case "top_right":
          (f += "right:20px;"), (f += "top:20px;");
          break;
        case "top_left":
          (f += "left:20px;"), (f += "top:20px;");
      }
    var w = window.csapps.settings.general.setting.upsell.sticky_opener;
    void 0 !== w && null != w && "enable" != w && (f += "display:none;");
    var b =
        void 0 !== l && null != l && "" != l
          ? l.setting.common_settings.upsell_launch_text
          : "",
      h =
        void 0 !== b && null != b && "" != b
          ? '<span class="aiod_uot" style="color: ' +
            n.upsell_icon_text_color +
            ";background-color:  " +
            n.upsell_icon_text_background_color +
            ';">' +
            b +
            "</span>"
          : "";
    s("body").append(
      '<div class="aiod_upsell_opener ' +
        g +
        '"  style=' +
        f +
        '><button type="button" class="up_icon" draggable="true" clickable="true"><div class="up_icon_wrpr" style="background-color: ' +
        n.upsell_icon_background_color +
        ';">' +
        window.csapps.offer_icon +
        '<span class="aiod_upsell_loading"></span></div>' +
        h +
        "</button></div>"
    );
    document.querySelector("html");
    var m = document.querySelector("body"),
      C = document.querySelector(".aiod_upsell_opener"),
      y = { distX: 0, distY: 0 };
    function x(s) {
      if ("none" === C.style.pointerEvents) {
        var e = "touchmove" === s.type ? s.changedTouches[0] : s;
        (C.style.left = e.clientX - y.distX + "px"),
          (C.style.top = e.clientY - y.distY + "px");
        var t = `${e.clientX - y.distX},${e.clientY - y.distY}`;
        csapps.set_local_data("aiod_upsell_opener_pos", t);
      }
    }
    C.addEventListener("mousedown", function (s) {
      s.preventDefault();
      var e = "touchstart" === s.type ? s.changedTouches[0] : s;
      (y.distX = Math.abs(C.offsetLeft - e.clientX)),
        (y.distY = Math.abs(C.offsetTop - e.clientY)),
        (C.style.pointerEvents = "none"),
        (window.csapps.pointer_p_s = C.offsetLeft + "," + C.offsetTop);
    }),
      m.addEventListener("mousemove", x),
      m.addEventListener("mouseup", function (s) {
        "none" === C.style.pointerEvents &&
          ((window.csapps.pointer_n_s = C.offsetLeft + "," + C.offsetTop),
          window.csapps.pointer_p_s === window.csapps.pointer_n_s &&
            aiod_upsell_reload(
              window.csapps.vd_url +
                "/api/display-upsell-popup?csapp=aiod&aiodupsell=true"
            )),
          (C.style.pointerEvents = "initial");
      }),
      m.addEventListener("touchmove", x),
      (window.csapp_add_time = function (s, e, t) {
        var o = new Date();
        return (
          o.setTime(o.getTime() + 24 * s * 60 * 60 * 1e3),
          o.setTime(o.getTime() + 60 * e * 60 * 1e3),
          o.setTime(o.getTime() + 60 * t * 1e3),
          o
        );
      }),
      (window.csapp_timer = function (e, t, o, a, i, l) {
        var d = setInterval(function () {
          var n = new Date().getTime(),
            p = e - n,
            c = Math.floor(p / 864e5),
            r = Math.floor((p % 864e5) / 36e5),
            _ = Math.floor((p % 36e5) / 6e4),
            u = Math.floor((p % 6e4) / 1e3),
            f = s(".special-bonus-bndl-discount[data-aio-upsell-id=" + t + "]");
          if (f.length)
            if (p < 0) {
              clearInterval(d),
                f
                  .find(".days_txt, .hours_txt, .minutes_txt, .seconds_txt")
                  .html("--"),
                f.find(".sb-offer-time-right").hide();
              var v = new Date(csapp_add_time(a, i, l)).getTime();
              csapps.set_local_data(o, v), csapp_timer(v, t, o, a, i, l);
            } else {
              f.find(".sb-offer-time-right").show(),
                f.find(".days_txt").html(c),
                f.find(".hours_txt").html(r),
                f.find(".minutes_txt").html(_),
                f.find(".seconds_txt").html(u);
              var g = 100 - (100 * c) / 99,
                w = 100 - (100 * r) / 24,
                b = 100 - (100 * _) / 60,
                h = 100 - (100 * u) / 60;
              f
                .find(".sbo-progress.days_wrpr .sbo-progress-inner")
                .attr("data-percent", g),
                f
                  .find(".sbo-progress.hours_wrpr .sbo-progress-inner")
                  .attr("data-percent", w),
                f
                  .find(".sbo-progress.minutes_wrpr .sbo-progress-inner")
                  .attr("data-percent", b),
                f
                  .find(".sbo-progress.seconds_wrpr .sbo-progress-inner")
                  .attr("data-percent", h),
                f.find(".sbo-progress-inner").each(function () {
                  var e = s(this),
                    t = e.attr("data-percent"),
                    o = 3.6 * t;
                  e
                    .find(".ppc-progress-fill")
                    .css("transform", "rotate(" + parseInt(o + 180) + "deg)"),
                    t >= 51
                      ? (e.addClass("percent_more"),
                        e
                          .find(".ppc-progress-fill")
                          .css(
                            "transform",
                            "rotate(" + parseInt(o + 180) + "deg)"
                          ))
                      : e.removeClass("percent_more");
                }),
                c > 0
                  ? (f.find(".sbo-progress.days_wrpr").show(),
                    f.find(".sbo-progress.seconds_wrpr").hide())
                  : (f.find(".sbo-progress.seconds_wrpr").show(),
                    f.find(".sbo-progress.days_wrpr").hide());
            }
        }, 1e3);
      }),
      (window.aiod_upsell_fill = function (o, a, i, n) {
        csapp_style(window.csapps.settings);
        var c = n.data,
          r = "",
          _ = "",
          u = "",
          f = -1,
          g =
            void 0 !== l && null != l && "" != l
              ? l.setting.common_settings
              : "",
          w =
            void 0 !== l && null != l && "" != l
              ? l.setting.free_gift_settings
              : "",
          b =
            '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="20" height="20" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><path xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256z" fill="#008060" fill-rule="evenodd" data-original="#008060" class="aiod_added_icon"></path><path xmlns="http://www.w3.org/2000/svg" d="m206.7 373.1c-32.7-32.7-65.2-65.7-98-98.4-3.6-3.6-3.6-9.6 0-13.2l37.7-37.7c3.6-3.6 9.6-3.6 13.2 0l53.9 53.9 138.6-138.7c3.7-3.6 9.6-3.6 13.3 0l37.8 37.8c3.7 3.7 3.7 9.6 0 13.2l-183.3 183.1c-3.6 3.7-9.5 3.7-13.2 0z" fill="#ffffff" data-original="#ffffff"></path></svg>',
          h = "",
          m = "",
          C = "",
          y = "",
          x = "",
          L = "",
          j = "",
          H = "",
          M = "",
          V = "",
          Z = "",
          A = "",
          T = "",
          B = "",
          D = "",
          k = "";
        if (
          (void 0 !== g &&
            null != g &&
            "" != g &&
            ((h =
              void 0 !== g.most_popular &&
              null != g.most_popular &&
              "" != g.most_popular
                ? '<div class="mst-pop">' + g.most_popular + "</div>"
                : ""),
            (m =
              void 0 !== g.days && null != g.days && "" != g.days
                ? g.days
                : ""),
            (C =
              void 0 !== g.hours && null != g.hours && "" != g.hours
                ? g.hours
                : ""),
            (y =
              void 0 !== g.minutes && null != g.minutes && "" != g.minutes
                ? g.minutes
                : ""),
            (x =
              void 0 !== g.seconds && null != g.seconds && "" != g.seconds
                ? g.seconds
                : "")),
          void 0 !== w &&
            null != w &&
            "" != w &&
            ((j =
              void 0 !== w.buy_label && null != w.buy_label && "" != w.buy_label
                ? '<span class="buy_free_aiod">' + w.buy_label + "</span>"
                : ""),
            (H =
              void 0 !== w.get_label && null != w.get_label && "" != w.get_label
                ? '<span class="get_free_aiod">' + w.get_label + "</span>"
                : ""),
            (M =
              void 0 !== w.max_qty_message &&
              null != w.max_qty_message &&
              "" != w.max_qty_message
                ? '<li class="max_selection">' + w.max_qty_message + "</li>"
                : ""),
            (V =
              void 0 !== w.select_message &&
              null != w.select_message &&
              "" != w.select_message
                ? '<li class="max_selection">' + w.select_message + "</li>"
                : ""),
            (Z =
              void 0 !== w.offer_type_collections_msg &&
              null != w.offer_type_collections_msg &&
              "" != w.offer_type_collections_msg
                ? w.offer_type_collections_msg
                : ""),
            (A =
              void 0 !== w.offer_type_products_msg &&
              null != w.offer_type_products_msg &&
              "" != w.offer_type_products_msg
                ? w.offer_type_products_msg
                : "")),
          void 0 !== p &&
            null != p &&
            "" != p &&
            ((T =
              void 0 !== p.buy_label && null != p.buy_label && "" != p.buy_label
                ? '<span class="buy_bogo_aiod">' + p.buy_label + "</span>"
                : ""),
            (B =
              void 0 !== p.get_label && null != p.get_label && "" != p.get_label
                ? '<span class="get_bogo_aiod">' + p.get_label + "</span>"
                : ""),
            (D =
              void 0 !== p.buy_quantity_message &&
              null != p.buy_quantity_message &&
              "" != p.buy_quantity_message
                ? '<ul class="bogo_msgs"><li>' +
                  p.buy_quantity_message +
                  "</li></ul>"
                : ""),
            (k =
              void 0 !== p.get_quantity_message &&
              null != p.get_quantity_message &&
              "" != p.get_quantity_message
                ? '<ul class="bogo_msgs"><li>' +
                  p.get_quantity_message +
                  "</li></ul>"
                : "")),
          void 0 !== c.id)
        ) {
          if (
            !s(".aiod_upsell_aiodp.cs_show").length &&
            ((r +=
              '<div class="aiod_upsell_overlay cs_overlay aiod_upsell_aiodp cs_show"></div><div class="aiod-special-bonus-aiodp aiod_upsell_aiodp cs_aiodp cs_show"><div class="cs_upsell_pop_close aiodp_close">' +
              close_svg +
              '</div><div class="special-bonus-aiodp-inner"><div class="special-bonus-head">'),
            (r +=
              null != c.title && "" != c.title
                ? "<h3>" + c.title + "</h3>"
                : ""),
            (r +=
              null != c.short_description && "" != c.short_description
                ? "<p>" + c.short_description + "</p>"
                : ""),
            (r += "</div>"),
            "1" == c.show_free_shipping_bar)
          ) {
            s("[data-aiod_ufp]").remove();
            var q =
                100 *
                Number(
                  c.free_shipping_bar[c.free_shipping_bar.length - 1].threshold
                ),
              E = (E = (100 * o.total_price) / q) > 100 ? 100 : E;
            s("body").append(
              "<style data-aiod_ufp>.aiod-special-bonus-aiodp ul.special-bonus-progress:after{width: " +
                E +
                "%;}</style>"
            ),
              s(c.free_shipping_bar).each(function (s, e) {
                var t = c.free_shipping_bar[s + 1],
                  a =
                    100 * Number(e.threshold) <= o.total_price
                      ? void 0 === t ||
                        (void 0 !== t &&
                          100 * Number(t.threshold) > o.total_price)
                        ? "current"
                        : "active"
                      : "";
                (_ +=
                  '<li class="sb-pro ' +
                  a +
                  '"><span class="sb-lbl">' +
                  e.title +
                  "</span></li>"),
                  "current" == a && (f = s);
              }),
              (u =
                void 0 !== (u = c.free_shipping_bar[f + 1])
                  ? "<h4>" +
                    u.message.replace(
                      "#amount#",
                      "<span class='money'>" +
                        csapps.formatMoney(
                          100 * Number(u.threshold) - o.total_price,
                          t
                        ) +
                        "</span>"
                    ) +
                    "</h4>"
                  : void 0 !== g.thank_you_message &&
                    null != g.thank_you_message &&
                    "" != g.thank_you_message
                  ? "<h4>" + g.thank_you_message + "</h4>"
                  : ""),
              (r +=
                "" != _
                  ? '<div class="aiod_free_ship_wrpr">' +
                    u +
                    '<ul class="special-bonus-progress ' +
                    [
                      "progress-one",
                      "progress-two",
                      "progress-three",
                      "progress-four",
                    ][c.free_shipping_bar.length - 1] +
                    '">' +
                    _ +
                    "</ul></div>"
                  : "");
          }
          s(c.upsell_offer_items.data).each(function (t, o) {
            var i = o.id,
              l = "cs_up_mili_" + i,
              n =
                void 0 !== o.description &&
                null != o.description &&
                "" != o.description
                  ? "<p>" + o.description + "</p>"
                  : "",
              p = csapps.get_local_data(l),
              c =
                7 != o.offer_tab_type
                  ? '<div class="bndl-check active">' + b + "</div>"
                  : "",
              r = "";
            if (
              (s(o.discounts).each(function (s, e) {
                -1 == a.indexOf(Number(e.id)) && (c = "");
              }),
              0 == o.offer_tab_type)
            )
              s(o.discounts).each(function (t, i) {
                var l = "",
                  d = "",
                  n = i.offer_type,
                  p = window.csapps.settings.language.setting.bundle_settings,
                  c = 0,
                  _ = i.id,
                  u =
                    a.indexOf(Number(_)) > -1
                      ? '<div class="bndl-check active">' + b + "</div>"
                      : "",
                  f =
                    "undefined" !== i.description &&
                    null != i.description &&
                    "" != i.description
                      ? '<p class="up_offer_desc">' + i.description + "</p>"
                      : "";
                s(i.products).each(function (t, o) {
                  var a =
                    window.csapps.aiod_root_url +
                    "/products/" +
                    o.handle +
                    ".js?csapp=aiod";
                  data = {
                    currency: window.csapps.currency_code,
                    country: window.csapps.country_code,
                  };
                  var i = csapps.create_api_url(a, data);
                  if (null == window.csapps.all_products[i])
                    s.ajax({
                      type: "GET",
                      url: a,
                      timeout: e,
                      dataType: "json",
                      async: !1,
                      success: function (s) {
                        (window.csapps.all_products[i] = s),
                          set_aiod_pdp_json(i, s),
                          (d += data_bundle_product(s, o, n, p));
                      },
                      error: function (s, e) {
                        c++;
                      },
                    });
                  else {
                    var l = window.csapps.all_products[i];
                    d += data_bundle_product(l, o, n, p);
                  }
                  if (c > 0) return !1;
                }),
                  0 == c &&
                    ((l +=
                      '<div class="csapps-bunlde-tiers" data-bundle_id="' +
                      _ +
                      '" data-hidden_p="' +
                      c +
                      '">'),
                    (l +=
                      u +
                      '<div class="offer_title_desc"><h4>' +
                      i.title +
                      "</h4>" +
                      f +
                      "</div>"),
                    (l +=
                      '<div data-product_count="' +
                      i.products.length +
                      '" class="csapps-bunlde-wrapper" data-discount_type="' +
                      i.discount_type +
                      '" data-discount_value="' +
                      i.discount_value +
                      '">'),
                    (l += d),
                    (l +=
                      '</div><div class="csapp_container_bundle"><div class="csapps-error"></div><div class="csapp_total_bundle"><div class="csapps-total_price"></div><div class="csapps-btn_wrapper"><button type="button" class="csapp_btn csapps-add-to-cart-btn">' +
                      o.button_text +
                      "</button></div></div></div>"),
                    (r += l += "</div>"));
              });
            else if (5 == o.offer_tab_type) {
              var _ = 1 == o.layout_selection ? " list_view" : "";
              s(o.discounts).each(function (t, i) {
                var l =
                    a.indexOf(Number(i.id)) > -1
                      ? '<div class="bndl-check active">' + b + "</div>"
                      : "",
                  d = "",
                  n = "",
                  p = "offer-grid-row",
                  c =
                    "undefined" !== i.description &&
                    null != i.description &&
                    "" != i.description
                      ? '<p class="up_offer_desc">' + i.description + "</p>"
                      : "";
                if (0 == i.offer_type || 3 == i.offer_type)
                  s(i.products).each(function (t, o) {
                    var a =
                      window.csapps.aiod_root_url +
                      "/products/" +
                      o.handle +
                      ".js?csapp=aiod";
                    data = {
                      currency: window.csapps.currency_code,
                      country: window.csapps.country_code,
                    };
                    var i = csapps.create_api_url(a, data);
                    if (null == window.csapps.all_products[i])
                      s.ajax({
                        type: "GET",
                        url: a,
                        timeout: e,
                        dataType: "json",
                        async: !1,
                        success: function (s) {
                          (window.csapps.all_products[i] = s),
                            set_aiod_pdp_json(i, s),
                            s.available &&
                              ((s.variants = s.variants.filter(function (s) {
                                return s.available;
                              })),
                              (n += free_gift_product_grid(s, o, "", 1, 0)));
                        },
                        error: function (s, e) {},
                      });
                    else {
                      var l = window.csapps.all_products[i];
                      l.available &&
                        ((l.variants = l.variants.filter(function (s) {
                          return s.available;
                        })),
                        (n += free_gift_product_grid(l, o, "", 1, 0)));
                    }
                  });
                else if (1 == i.offer_type && "" != Z) {
                  p = "";
                  var u = [];
                  s(i.collections).each(function (s, e) {
                    u.push(
                      "<a href='" +
                        window.csapps.aiod_root_url +
                        "/collections/" +
                        e.handle +
                        "'>" +
                        e.title +
                        "</a>"
                    );
                  }),
                    (n +=
                      '<p class="buy_freegift_collection">' +
                      Z.replace("{{collections}}", u.join(", ")) +
                      "</p>");
                } else
                  2 == i.offer_type &&
                    "" != A &&
                    ((p = ""),
                    (n +=
                      '<p class="buy_freegift_collection"><a href="' +
                      window.csapps.aiod_root_url +
                      '/collections/all">' +
                      A +
                      "</a></p>"));
                if (
                  (s(i.free_gift_products).each(function (t, o) {
                    var a =
                        window.csapps.aiod_root_url +
                        "/products/" +
                        o.handle +
                        ".js?csapp=aiod",
                      l = i.max_discount,
                      n = i.discount_type,
                      p = i.discount_value;
                    data = {
                      currency: window.csapps.currency_code,
                      country: window.csapps.country_code,
                    };
                    var c = csapps.create_api_url(a, data);
                    if (null == window.csapps.all_products[c])
                      s.ajax({
                        type: "GET",
                        url: a,
                        timeout: e,
                        dataType: "json",
                        async: !1,
                        success: function (s) {
                          (window.csapps.all_products[c] = s),
                            set_aiod_pdp_json(c, s),
                            s.available &&
                              ((s.variants = s.variants.filter(function (s) {
                                return s.available;
                              })),
                              (d += free_gift_product_grid(s, o, l, n, p)));
                        },
                        error: function (s, e) {},
                      });
                    else {
                      var r = window.csapps.all_products[c];
                      r.available &&
                        ((r.variants = r.variants.filter(function (s) {
                          return s.available;
                        })),
                        (d += free_gift_product_grid(r, o, l, n, p)));
                    }
                  }),
                  "" != d)
                ) {
                  (r += '<div class="offer-grid">' + l),
                    (r +=
                      '<div class="offer_title_desc"><h4>' +
                      i.title +
                      "</h4>" +
                      c +
                      "</div>"),
                    "" != n &&
                      ((r +=
                        '<div class="aiod_free_buy_wrpr aiod_free_wrpr" data-atc="' +
                        v +
                        '">' +
                        j +
                        '<div class="buy_type freegift ' +
                        p +
                        _ +
                        '" data-max_gift="' +
                        i.maximum_gift_selection +
                        '">'),
                      (r += n),
                      (r += "</div></div>")),
                    (r +=
                      '<div class="aiod_free_get_wrpr aiod_free_wrpr" data-atc="' +
                      v +
                      '">' +
                      H);
                  var f = M;
                  (f =
                    void 0 !== i.maximum_gift_selection &&
                    null != i.maximum_gift_selection &&
                    "" != i.maximum_gift_selection &&
                    "" != f
                      ? f.replace("{{quantity}}", i.maximum_gift_selection)
                      : ""),
                    (r +=
                      "" != f || "" != V
                        ? '<ul class="free_gift_msgs">' + f + V + "</ul>"
                        : ""),
                    (r +=
                      '<div class="get_type freegift offer-grid-row ' +
                      _ +
                      '" data-max_gift="' +
                      i.maximum_gift_selection +
                      '" data-show_atc="' +
                      v +
                      '">'),
                    (r += d),
                    (r += "</div>"),
                    v &&
                      (r +=
                        '<div class="admore-btn"><button type="button" class="csapp_btn upsell_free_g_add">' +
                        o.button_text +
                        "</button></div>"),
                    (r += "</div></div>");
                }
              });
            } else if (3 == o.offer_tab_type) {
              _ = 1 == o.layout_selection ? " list_view" : "";
              var u = window.csapps.settings.language.setting.bogo_settings,
                f = "";
              (window.csapps.bogo_atc =
                null != u.add_to_cart_button_text &&
                "" != u.add_to_cart_button_text
                  ? u.add_to_cart_button_text
                  : "Add To Cart"),
                (window.csapps.bogo_soldout =
                  null != u.sold_out_button_text && "" != u.sold_out_button_text
                    ? u.sold_out_button_text
                    : "Sold out"),
                s(o.discounts).each(function (t, o) {
                  var i =
                      a.indexOf(Number(o.id)) > -1
                        ? '<div class="bndl-check active">' + b + "</div>"
                        : "",
                    l = "",
                    d = "",
                    n =
                      void 0 !== o.description &&
                      null != o.description &&
                      "" != o.description
                        ? '<p class="bogo_desc_content">' +
                          o.description +
                          "</p>"
                        : "";
                  if ("Collections" == o.offer_type_text) {
                    ("is_grid");
                    var p =
                        2 == o.setting_type &&
                        null != o.setting_json &&
                        void 0 !== o.setting_json.store_collection_message &&
                        "" != o.setting_json.store_collection_message &&
                        null != o.setting_json.store_collection_message
                          ? o.setting_json.store_collection_message
                          : 1 == o.setting_type &&
                            null != u &&
                            void 0 !== u.store_collection_message &&
                            "" != u.store_collection_message &&
                            null != u.store_collection_message
                          ? u.store_collection_message
                          : "",
                      c = [],
                      r = 0;
                    s(o.collections).each(function (t, o) {
                      0 == r &&
                        (r++,
                        s.ajax({
                          type: "GET",
                          url:
                            "/collections/" +
                            o.handle +
                            "/products.json?limit=3",
                          timeout: e,
                          dataType: "json",
                          async: !1,
                          success: function (t) {
                            if (void 0 !== t && null != t) {
                              var o = "";
                              s(t.products).each(function (t, a) {
                                var i = [];
                                s(a.variants).each(function (s, e) {
                                  i.push(e.id);
                                }),
                                  (i = i.join(","));
                                var l =
                                  "/products/" + a.handle + ".js?csapp=aiod";
                                data = {
                                  currency: window.csapps.currency_code,
                                  country: window.csapps.country_code,
                                };
                                var d = csapps.create_api_url(l, data);
                                if (null == window.csapps.all_products[d])
                                  s.ajax({
                                    type: "GET",
                                    url: l,
                                    timeout: e,
                                    dataType: "json",
                                    async: !1,
                                    success: function (s) {
                                      (window.csapps.all_products[d] = s),
                                        set_aiod_pdp_json(d, s),
                                        (o += bogo_pop_gird(s, i, 1, 0));
                                    },
                                    error: function (s, e) {},
                                  });
                                else {
                                  var n = window.csapps.all_products[d];
                                  o += bogo_pop_gird(n, i, 1, 0);
                                }
                              }),
                                "" != o &&
                                  (d +=
                                    '<div class="bogo_collection_wrpr">' +
                                    o +
                                    "</div>");
                            }
                          },
                          error: function (s, e) {
                            console.log("AIOD collection not found");
                          },
                        })),
                        c.push(
                          "<a href='" +
                            window.csapps.aiod_root_url +
                            "/collections/" +
                            o.handle +
                            "'>" +
                            o.title +
                            "</a>"
                        );
                    }),
                      (c = c.join(", ")),
                      (d +=
                        "<p class='bogo_desc_wrpr'>" + p + " " + c + "</p>");
                  } else
                    "is_grid",
                      o.products.length &&
                        s(o.products).each(function (t, o) {
                          var a = o.default_variant_ids,
                            i =
                              window.csapps.aiod_root_url +
                              "/products/" +
                              o.handle +
                              ".js?csapp=aiod";
                          data = {
                            currency: window.csapps.currency_code,
                            country: window.csapps.country_code,
                          };
                          var l = csapps.create_api_url(i, data);
                          if (null == window.csapps.all_products[l])
                            s.ajax({
                              type: "GET",
                              url: i,
                              timeout: e,
                              dataType: "json",
                              async: !1,
                              success: function (s) {
                                (window.csapps.all_products[l] = s),
                                  set_aiod_pdp_json(l, s),
                                  (d += bogo_pop_gird(s, a, 1, 0));
                              },
                              error: function (s, e) {},
                            });
                          else {
                            var n = window.csapps.all_products[l];
                            d += bogo_pop_gird(n, a, 1, 0);
                          }
                        });
                  if ("All" == o.selection_type_get_text) {
                    var v =
                      2 == o.setting_type &&
                      null != o.setting_json &&
                      void 0 !== o.setting_json.store_product_message &&
                      "" != o.setting_json.store_product_message &&
                      null != o.setting_json.store_product_message
                        ? o.setting_json.store_product_message
                        : 1 == o.setting_type &&
                          null != u &&
                          void 0 !== u.store_product_message &&
                          "" != u.store_product_message &&
                          null != u.store_product_message
                        ? u.store_product_message
                        : "";
                    l +=
                      "" != v
                        ? "<p><a href='" +
                          window.csapps.aiod_root_url +
                          "/collections/all'>" +
                          v +
                          "</a></p>"
                        : "";
                  } else if ("Collections" == o.offer_type_get_text) {
                    ("is_grid");
                    p =
                      2 == o.setting_type &&
                      null != o.setting_json &&
                      void 0 !== o.setting_json.store_collection_message &&
                      "" != o.setting_json.store_collection_message &&
                      null != o.setting_json.store_collection_message
                        ? o.setting_json.store_collection_message
                        : 1 == o.setting_type &&
                          null != u &&
                          void 0 !== u.store_collection_message &&
                          "" != u.store_collection_message &&
                          null != u.store_collection_message
                        ? u.store_collection_message
                        : "";
                    var g = [];
                    r = 0;
                    s(o.collections_get).each(function (t, a) {
                      0 == r &&
                        (r++,
                        s.ajax({
                          type: "GET",
                          url:
                            "/collections/" +
                            a.handle +
                            "/products.json?limit=3",
                          timeout: e,
                          dataType: "json",
                          async: !1,
                          success: function (t) {
                            if (void 0 !== t && null != t) {
                              var a = "";
                              s(t.products).each(function (t, i) {
                                var l = [];
                                s(i.variants).each(function (s, e) {
                                  l.push(e.id);
                                }),
                                  (l = l.join(","));
                                var d =
                                  "/products/" + i.handle + ".js?csapp=aiod";
                                data = {
                                  currency: window.csapps.currency_code,
                                  country: window.csapps.country_code,
                                };
                                var n = csapps.create_api_url(d, data);
                                if (null == window.csapps.all_products[n])
                                  s.ajax({
                                    type: "GET",
                                    url: d,
                                    timeout: e,
                                    dataType: "json",
                                    async: !1,
                                    success: function (s) {
                                      (window.csapps.all_products[n] = s),
                                        set_aiod_pdp_json(n, s),
                                        (a += bogo_pop_gird(
                                          s,
                                          l,
                                          o.discount_type,
                                          o.discount_value
                                        ));
                                    },
                                    error: function (s, e) {},
                                  });
                                else {
                                  var p = window.csapps.all_products[n];
                                  a += bogo_pop_gird(
                                    p,
                                    l,
                                    o.discount_type,
                                    o.discount_value
                                  );
                                }
                              }),
                                "" != a &&
                                  (l +=
                                    '<div class="bogo_collection_wrpr">' +
                                    a +
                                    "</div>");
                            }
                          },
                          error: function (s, e) {
                            console.log("AIOD collection not found");
                          },
                        })),
                        g.push(
                          "<a href='" +
                            window.csapps.aiod_root_url +
                            "/collections/" +
                            a.handle +
                            "'>" +
                            a.title +
                            "</a>"
                        );
                    }),
                      (g = g.join(", ")),
                      (l +=
                        "<p class='bogo_desc_wrpr'>" + p + " " + g + "</p>");
                  } else
                    "is_grid",
                      o.products_get.length &&
                        s(o.products_get).each(function (t, a) {
                          var i = a.default_variant_ids,
                            d =
                              window.csapps.aiod_root_url +
                              "/products/" +
                              a.handle +
                              ".js?csapp=aiod";
                          data = {
                            currency: window.csapps.currency_code,
                            country: window.csapps.country_code,
                          };
                          var n = csapps.create_api_url(d, data);
                          if (null == window.csapps.all_products[n])
                            s.ajax({
                              type: "GET",
                              url: d,
                              timeout: e,
                              dataType: "json",
                              async: !1,
                              success: function (s) {
                                (window.csapps.all_products[n] = s),
                                  set_aiod_pdp_json(n, s),
                                  (l += bogo_pop_gird(
                                    s,
                                    i,
                                    o.discount_type,
                                    o.discount_value
                                  ));
                              },
                              error: function (s, e) {},
                            });
                          else {
                            var p = window.csapps.all_products[n];
                            l += bogo_pop_gird(
                              p,
                              i,
                              o.discount_type,
                              o.discount_value
                            );
                          }
                        });
                  if ("" != d && "" != l) {
                    var w =
                        "Collections" == o.offer_type_text
                          ? " is_collection "
                          : "",
                      h =
                        "Collections" == o.offer_type_get_text
                          ? " is_collection "
                          : "";
                    (f +=
                      '<div class="offer-grid">' +
                      i +
                      '<div class="offer_title_desc"><h4>' +
                      o.title +
                      "</h4>" +
                      n +
                      "</div>"),
                      (f +=
                        '<div class="aiod_bogo_buy_wrpr aiod_bogo_wrpr">' +
                        T +
                        D.replace("{{quantity}}", o.bogo_quantity_buy)),
                      (f +=
                        '<div class="buy_type bogo offer-grid-row ' +
                        w +
                        _ +
                        '">' +
                        d +
                        "</div></div>"),
                      (f +=
                        '<div class="aiod_bogo_get_wrpr aiod_bogo_wrpr">' +
                        B +
                        k.replace("{{quantity}}", o.bogo_quantity_get)),
                      (f +=
                        '<div class="get_type bogo offer-grid-row ' +
                        h +
                        _ +
                        '">' +
                        l +
                        "</div></div></div>");
                  }
                }),
                "" != f && (r += f);
            } else
              7 == o.offer_tab_type &&
                s(o.discount_codes).each(function (s, e) {
                  if (1 == e.status) {
                    var t =
                        window.csapps.csapp_discount_code.indexOf(e.title) > -1
                          ? "active_aiodcode"
                          : "",
                      o =
                        void 0 !== d.apply_btn_text &&
                        null != d.apply_btn_text &&
                        "" != d.apply_btn_text
                          ? d.apply_btn_text
                          : "Apply",
                      a =
                        void 0 !== d.applied_btn_text &&
                        null != d.applied_btn_text &&
                        "" != d.applied_btn_text
                          ? d.applied_btn_text
                          : "Applied";
                    (bnt_text =
                      window.csapps.csapp_discount_code.indexOf(e.title) > -1
                        ? a
                        : o),
                      (code_desc =
                        void 0 !== e.short_description &&
                        null != e.short_description &&
                        "" != e.short_description
                          ? "<p>" + e.short_description + "</p>"
                          : ""),
                      (r +=
                        '<div class="up_aiodcode_wrpr ' +
                        t +
                        '"><div class="upaiodcode_cnt_wrpr"><h3>' +
                        e.title +
                        "</h3>" +
                        code_desc +
                        '</div><button type="button" class="btn button aiod_discount_code" data-value="' +
                        e.title +
                        '">' +
                        bnt_text +
                        "</button></div>");
                  }
                });
            if ("" != r) {
              var g = "";
              0 == o.offer_tab_type
                ? (g =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#clip0_1411_3181)"><path d="M19.166 40H10.8327C4.49935 40 1.66602 34.5583 1.66602 29.1667C1.66602 21.4283 5.74935 13.415 11.3777 10.115C11.5044 10.04 11.651 10 11.7994 10H21.5327C21.681 10 21.826 10.04 21.9544 10.115C25.306 12.0783 28.1244 15.6283 29.891 20.1117C30.061 20.54 29.851 21.0233 29.4227 21.1933C28.996 21.3583 28.511 21.1517 28.3427 20.7233C26.7444 16.6717 24.2494 13.4667 21.3027 11.6667H12.031C6.97935 14.7567 3.33268 22.07 3.33268 29.1667C3.33268 33.395 5.29768 38.3333 10.8327 38.3333H19.166C19.626 38.3333 19.9994 38.7067 19.9994 39.1667C19.9994 39.6267 19.626 40 19.166 40Z" fill="#5EB9F0"/><path d="M22.5007 11.6665H10.834C9.45565 11.6665 8.33398 10.5448 8.33398 9.1665C8.33398 7.78817 9.45565 6.6665 10.834 6.6665H22.5007C23.879 6.6665 25.0007 7.78817 25.0007 9.1665C25.0007 10.5448 23.879 11.6665 22.5007 11.6665ZM10.834 8.33317C10.3757 8.33317 10.0007 8.7065 10.0007 9.1665C10.0007 9.6265 10.3757 9.99984 10.834 9.99984H22.5007C22.959 9.99984 23.334 9.6265 23.334 9.1665C23.334 8.7065 22.959 8.33317 22.5007 8.33317H10.834Z" fill="#5EB9F0"/><path d="M20.8329 8.33333C20.5896 8.33333 20.3462 8.22667 20.1812 8.02C19.8946 7.66 19.9512 7.13667 20.3112 6.84833L24.9329 3.15C25.3612 2.80667 25.2462 2.35333 25.1996 2.22333C25.1562 2.09333 24.9646 1.66667 24.4146 1.66667H8.91789C8.36789 1.66667 8.17623 2.09333 8.13123 2.22333C8.08623 2.355 7.96956 2.80833 8.39789 3.15L13.0196 6.84833C13.3796 7.13667 13.4362 7.66 13.1496 8.02C12.8612 8.38 12.3379 8.43667 11.9779 8.15L7.35623 4.45167C6.51456 3.78 6.20289 2.68833 6.55956 1.67167C6.91623 0.655 7.84123 0 8.91789 0H24.4162C25.4929 0 26.4179 0.656667 26.7746 1.67167C27.1312 2.68667 26.8179 3.77833 25.9762 4.45167L21.3546 8.15C21.1996 8.27333 21.0162 8.33333 20.8329 8.33333Z" fill="#5EB9F0"/><path d="M24.9993 30.0002C23.161 30.0002 21.666 28.5052 21.666 26.6668C21.666 24.8285 23.161 23.3335 24.9993 23.3335C26.8377 23.3335 28.3327 24.8285 28.3327 26.6668C28.3327 28.5052 26.8377 30.0002 24.9993 30.0002ZM24.9993 25.0002C24.0793 25.0002 23.3327 25.7485 23.3327 26.6668C23.3327 27.5852 24.0793 28.3335 24.9993 28.3335C25.9193 28.3335 26.666 27.5852 26.666 26.6668C26.666 25.7485 25.9193 25.0002 24.9993 25.0002Z" fill="#5EB9F0"/><path d="M34.9993 40.0002C33.161 40.0002 31.666 38.5052 31.666 36.6668C31.666 34.8285 33.161 33.3335 34.9993 33.3335C36.8377 33.3335 38.3327 34.8285 38.3327 36.6668C38.3327 38.5052 36.8377 40.0002 34.9993 40.0002ZM34.9993 35.0002C34.0793 35.0002 33.3327 35.7485 33.3327 36.6668C33.3327 37.5852 34.0793 38.3335 34.9993 38.3335C35.9193 38.3335 36.666 37.5852 36.666 36.6668C36.666 35.7485 35.9193 35.0002 34.9993 35.0002Z" fill="#5EB9F0"/><path d="M24.1666 40C23.9883 40 23.8066 39.9433 23.6549 39.825C23.2899 39.5434 23.2249 39.02 23.5083 38.655L35.1749 23.655C35.4583 23.2917 35.9799 23.225 36.3433 23.51C36.7083 23.7917 36.7733 24.315 36.4899 24.68L24.8233 39.68C24.6599 39.89 24.4133 40 24.1666 40Z" fill="#5EB9F0"/></g><defs><clipPath id="clip0_1411_3181"><rect width="40" height="40" fill="white"/></clipPath></defs></svg>')
                : 5 == o.offer_tab_type
                ? (g =
                    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.7393 27.2981C39.2659 26.4194 38.4797 25.7791 37.5255 25.4948C37.1747 25.3903 36.8166 25.3391 36.4605 25.3392L36.3548 25.1354C36.3533 25.1327 36.3519 25.13 36.3504 25.1273C35.8771 24.2487 35.091 23.6083 34.1368 23.3241C33.8453 23.2372 33.5489 23.1873 33.2527 23.1728V12.9086H33.2636C34.228 12.9086 35.0127 12.1235 35.0127 11.1585V7.62175C35.0127 6.65668 34.228 5.87159 33.2636 5.87159H32.9274L32.7882 3.77325C32.6639 1.90224 31.2285 0.345421 29.3751 0.0716167C27.1192 -0.261558 24.8863 0.584854 23.4205 2.29572C23.037 2.07996 22.5953 1.9563 22.1249 1.9563H20.3754C19.9051 1.9563 19.4633 2.07996 19.0798 2.29564C17.6141 0.584854 15.3818 -0.261949 13.1252 0.0716167C12.7814 0.122393 12.4458 0.217463 12.1278 0.354249C11.8304 0.48205 11.6932 0.826708 11.821 1.12395C11.9487 1.42119 12.2931 1.55852 12.5907 1.43064C12.8155 1.33401 13.0529 1.26675 13.2965 1.23074C15.1598 0.955369 17.005 1.65968 18.2096 3.08065C17.9031 3.51366 17.7223 4.04167 17.7223 4.61146V5.87151H10.7472L10.8813 3.8509C10.8988 3.58788 10.9522 3.32962 11.0403 3.08323C11.1491 2.77849 10.9903 2.44329 10.6855 2.33447C10.3809 2.22557 10.0456 2.38439 9.93665 2.6892C9.81229 3.03746 9.73667 3.40219 9.71206 3.77325L9.57278 5.87151H9.23663C8.27218 5.87151 7.48756 6.65668 7.48756 7.62167V11.1583C7.48756 12.1234 8.27218 12.9085 9.23663 12.9085H9.24749V23.2859C8.13118 23.5915 7.22665 24.0653 6.56389 24.5301V24.3185C6.56389 23.5648 5.95059 22.9514 5.19682 22.9514H1.36903C0.61526 22.9514 0.00195312 23.5648 0.00195312 24.3185V30.6961C0.00195312 31.0197 0.264196 31.282 0.58784 31.282C0.911484 31.282 1.17373 31.0197 1.17373 30.6961V24.3185C1.17373 24.2109 1.2613 24.1232 1.36903 24.1232H5.19682C5.30455 24.1232 5.39212 24.2109 5.39212 24.3185V25.8187V25.8201V37.5564C5.39212 37.664 5.30455 37.7517 5.19682 37.7517H1.36903C1.2613 37.7517 1.17373 37.664 1.17373 37.5564V33.4472C1.17373 33.1236 0.911484 32.8613 0.58784 32.8613C0.264196 32.8613 0.00195312 33.1236 0.00195312 33.4472V37.5564C0.00195312 38.3101 0.61526 38.9234 1.36903 38.9234H5.19682C5.95059 38.9234 6.56389 38.3101 6.56389 37.5564V36.3558L13.7172 39.189C15.0859 39.7311 16.5226 39.9999 17.955 39.9999C19.8472 39.9999 21.7318 39.5307 23.4409 38.6025L29.2934 35.4244C29.5777 35.2699 29.683 34.9142 29.5287 34.6299C29.3742 34.3455 29.0185 34.2402 28.7342 34.3946L22.8817 37.5728C20.1847 39.0375 17.0016 39.2295 14.1487 38.0995L6.56389 35.0953V26.0449C7.35515 25.2215 9.26694 24.1233 11.77 24.1233C14.0358 24.1233 15.4975 24.3198 16.5094 24.7602C16.8388 24.9035 17.3875 25.1765 18.0279 25.5066C18.0292 25.5072 18.0304 25.5079 18.0316 25.5085C19.9854 26.5157 22.7895 28.0537 22.8268 28.0743C22.8301 28.0761 22.8333 28.0778 22.8367 28.0796C24.0779 28.7304 24.5593 30.2724 23.9098 31.517C23.7887 31.749 23.5848 31.9198 23.3355 31.9979C23.0873 32.0757 22.8233 32.0519 22.5926 31.931L14.8359 27.8638C14.5495 27.7135 14.1952 27.8241 14.0449 28.1106C13.8947 28.3971 14.0052 28.7513 14.2918 28.9016L22.0485 32.9687C22.3605 33.1323 22.6999 33.2152 23.0422 33.2152C23.2577 33.2152 23.4742 33.1824 23.6857 33.1161C23.8332 33.07 23.9731 33.0086 24.1046 32.9342L35.2555 26.8203C35.8527 26.4959 36.54 26.424 37.191 26.6179C37.8445 26.8125 38.3832 27.2515 38.7077 27.8539C38.9662 28.3336 38.7883 28.9346 38.3113 29.1937L31.1046 33.1073C30.8203 33.2617 30.715 33.6174 30.8693 33.9018C30.9755 34.0973 31.1769 34.2081 31.3848 34.2081C31.4792 34.2081 31.5751 34.1852 31.6638 34.137L38.8705 30.2233C39.9134 29.657 40.3031 28.3447 39.7393 27.2981ZM33.8409 7.62175V11.1584C33.8409 11.4774 33.5819 11.7368 33.2636 11.7368H30.135C29.8114 11.7368 29.5491 11.9991 29.5491 12.3227C29.5491 12.6462 29.8114 12.9086 30.135 12.9086H32.081V23.3061C31.8153 23.3809 31.5557 23.4849 31.307 23.6199L24.778 27.1715V12.9086H27.4009C27.7245 12.9086 27.9868 12.6463 27.9868 12.3228C27.9868 11.9992 27.7245 11.7369 27.4009 11.7369H24.778V7.04336H33.2636C33.5818 7.04336 33.8409 7.30287 33.8409 7.62175ZM18.894 7.04336H23.6062V11.7369H18.894V7.04336ZM29.2037 1.23081C30.5152 1.42455 31.531 2.52648 31.619 3.8509L31.7531 5.87159H24.7779V4.61154C24.7779 4.04174 24.5971 3.51374 24.2906 3.08073C25.4951 1.65968 27.3399 0.955291 29.2037 1.23081ZM22.1249 3.12807C22.9417 3.12807 23.6062 3.79356 23.6062 4.61154V5.87159H18.894V4.61154C18.894 3.79356 19.5585 3.12807 20.3753 3.12807H22.1249ZM8.65926 11.1584V7.62175C8.65926 7.30279 8.91822 7.04336 9.23655 7.04336H17.7222V11.7369H9.23655C8.91822 11.7369 8.65926 11.4774 8.65926 11.1584ZM11.7699 22.9515C11.2969 22.9515 10.8467 22.986 10.4191 23.0459V12.9086H17.7221V24.0385C17.4226 23.8902 17.1671 23.7686 16.9769 23.6858C15.7945 23.1711 14.2373 22.9515 11.7699 22.9515ZM18.894 24.6355V12.9086H23.6062V27.1715C23.5344 27.1273 23.4615 27.0843 23.3858 27.0445C23.1993 26.9422 20.7877 25.62 18.894 24.6355ZM25.3225 30.9302C25.4603 30.0726 25.2908 29.198 24.8617 28.46L31.8668 24.6495C32.1375 24.5025 32.4269 24.4078 32.7229 24.3658C32.7287 24.3652 32.7344 24.3643 32.7401 24.3635C33.0917 24.3161 33.4522 24.3427 33.8024 24.447C34.4063 24.6269 34.9118 25.0158 35.2412 25.5492C35.0546 25.615 34.8717 25.6954 34.6942 25.7917L25.3225 30.9302Z" fill="#FAB758"/><path d="M3.08494 9.95829L4.40693 9.9868C4.41131 9.98688 4.41552 9.98696 4.41982 9.98696C4.73745 9.98696 4.99844 9.73292 5.00532 9.41372C5.01235 9.09023 4.75573 8.82237 4.43224 8.81534L3.11025 8.78682C2.78395 8.77846 2.51881 9.03649 2.51186 9.3599C2.50491 9.68347 2.76153 9.95133 3.08494 9.95829Z" fill="#FAB758"/><path d="M3.66087 6.89392L4.79156 7.58034C4.88655 7.63799 4.99146 7.66549 5.09505 7.66549C5.293 7.66549 5.48619 7.56511 5.59641 7.38356C5.76429 7.10695 5.67617 6.74659 5.39955 6.57871L4.26887 5.89228C3.99241 5.72433 3.63197 5.81252 3.46402 6.08906C3.29614 6.36568 3.38426 6.72604 3.66087 6.89392Z" fill="#FAB758"/><path d="M4.71292 11.2367L3.55381 11.8736C3.27024 12.0295 3.16673 12.3857 3.3225 12.6693C3.42913 12.8633 3.62966 12.9732 3.83652 12.9732C3.9319 12.9732 4.02861 12.9498 4.11813 12.9006L5.27725 12.2636C5.56082 12.1078 5.66433 11.7515 5.50856 11.468C5.35271 11.1844 4.99665 11.0807 4.71292 11.2367Z" fill="#FAB758"/><path d="M37.4943 9.41375C37.5012 9.73294 37.7621 9.98698 38.0798 9.98698C38.0841 9.98698 38.0883 9.98698 38.0927 9.98683L39.4147 9.95832C39.7382 9.95136 39.9948 9.68342 39.9878 9.35993C39.9807 9.03644 39.7146 8.77787 39.3894 8.78685L38.0674 8.81537C37.7439 8.8224 37.4873 9.09026 37.4943 9.41375Z" fill="#FAB758"/><path d="M37.4049 7.66553C37.5085 7.66553 37.6134 7.63803 37.7084 7.58038L38.8391 6.89395C39.1157 6.72608 39.2038 6.36572 39.0359 6.0891C38.868 5.8124 38.5075 5.72437 38.2311 5.89232L37.1004 6.57874C36.8238 6.74662 36.7356 7.10698 36.9035 7.3836C37.0137 7.56514 37.2069 7.66553 37.4049 7.66553Z" fill="#FAB758"/><path d="M37.7881 11.2366C37.5046 11.0807 37.1484 11.1843 36.9924 11.468C36.8367 11.7515 36.9402 12.1077 37.2237 12.2636L38.3829 12.9006C38.4724 12.9498 38.5691 12.9731 38.6645 12.9731C38.8713 12.9731 39.0719 12.8634 39.1785 12.6693C39.3343 12.3857 39.2308 12.0295 38.9472 11.8736L37.7881 11.2366Z" fill="#FAB758"/></svg>')
                : 3 == o.offer_tab_type &&
                  (g =
                    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.3333 18.6667H32.6494C33.0905 18.0931 33.3307 17.3903 33.3333 16.6667C33.3376 15.2288 32.4167 13.9515 31.0511 13.501C29.6859 13.0508 28.1855 13.5293 27.3333 14.6875C27.2386 14.5527 27.1344 14.4251 27.0215 14.3053C26.5586 13.846 25.972 13.5313 25.3333 13.4001V11.3333C25.3333 10.9652 25.0348 10.6667 24.6667 10.6667H22.6667V6C22.6631 2.68783 19.9788 0.00358516 16.6667 4.43027e-06H15.3333C14.5319 -0.000972136 13.7383 0.15951 13 0.472009C12.2617 0.15951 11.4681 -0.000972136 10.6667 4.43027e-06H9.33333C6.02116 0.00358516 3.33691 2.68783 3.33333 6V10.6667H0.666667C0.298503 10.6667 0 10.9652 0 11.3333V39.3333C0 39.7015 0.298503 40 0.666667 40H38C38.3682 40 38.6667 39.7015 38.6667 39.3333V25.3333H39.3333C39.7015 25.3333 40 25.0348 40 24.6667V19.3333C40 18.9652 39.7015 18.6667 39.3333 18.6667ZM30 14.6667C31.1045 14.6667 32 15.5622 32 16.6667C32 17.7712 31.1045 18.6667 30 18.6667H28V16.6667C28 15.5622 28.8955 14.6667 30 14.6667ZM26.0788 15.248C26.4544 15.6247 26.666 16.1348 26.6667 16.6667V18.6667H25.3333V14.7887C25.6123 14.8854 25.8669 15.0423 26.0788 15.248ZM15.3333 1.33334H16.6667C19.2428 1.33627 21.3304 3.42383 21.3333 6V10.6667H16.6667V6C16.6667 4.22754 15.8812 2.54623 14.5221 1.40853C14.7897 1.3597 15.0612 1.33464 15.3333 1.33334ZM13 1.96452C14.4421 2.7972 15.3311 4.33496 15.3333 6V10.6667H10.6667V6C10.6689 4.33496 11.5579 2.7972 13 1.96452ZM4.66667 6C4.6696 3.42383 6.75716 1.33627 9.33333 1.33334H10.6667C10.9388 1.33464 11.2103 1.3597 11.4779 1.40853C10.1188 2.54623 9.33333 4.22754 9.33333 6V10.6667H4.66667V6ZM5.91016 12L4 14.292L2.08984 12H5.91016ZM2.08984 38.6667L4 36.3747L5.91016 38.6667H2.08984ZM24 30.6667V38.6667H8V30.6667H6.66667V37.4919L4.51269 34.9066C4.38184 34.7617 4.19531 34.6787 4 34.6787C3.80469 34.6787 3.61816 34.7617 3.4873 34.9066L1.33333 37.4919V13.1748L3.4873 15.7601C3.61393 15.9124 3.80176 16.0007 4 16.0007C4.19824 16.0007 4.38607 15.9124 4.51269 15.7601L6.66667 13.1748V20H8V12H24V20H30V24H26V25.3333H30V38.6667H25.3333V30.6667H24ZM37.3333 38.6667H31.3333V25.3333H37.3333V38.6667ZM38.6667 24H31.3333V20H38.6667V24Z" fill="#605DBA"/><path d="M11.5286 28.862L19.529 20.862L20.4717 21.8047L12.4717 29.8051L11.5286 28.862Z" fill="#605DBA"/><path d="M20.6667 28C20.6667 26.8956 19.7712 26 18.6667 26C17.5622 26 16.6667 26.8956 16.6667 28C16.6667 29.1045 17.5622 30 18.6667 30C19.7712 30 20.6667 29.1045 20.6667 28ZM18 28C18 27.6319 18.2985 27.3334 18.6667 27.3334C19.0348 27.3334 19.3333 27.6319 19.3333 28C19.3333 28.3682 19.0348 28.6667 18.6667 28.6667C18.2985 28.6667 18 28.3682 18 28Z" fill="#605DBA"/><path d="M11.3333 22.6667C11.3333 23.7712 12.2288 24.6667 13.3333 24.6667C14.4378 24.6667 15.3333 23.7712 15.3333 22.6667C15.3333 21.5622 14.4378 20.6667 13.3333 20.6667C12.2288 20.6667 11.3333 21.5622 11.3333 22.6667ZM14 22.6667C14 23.0349 13.7015 23.3334 13.3333 23.3334C12.9652 23.3334 12.6667 23.0349 12.6667 22.6667C12.6667 22.2986 12.9652 22 13.3333 22C13.7015 22 14 22.2986 14 22.6667Z" fill="#605DBA"/><path d="M7.45638 23.7341L7.80143 22.446L9.0892 22.7911L8.74414 24.0792L7.45638 23.7341Z" fill="#605DBA"/><path d="M7.33334 24.6667H8.66667V26H7.33334V24.6667Z" fill="#605DBA"/><path d="M7.45606 26.9327L8.74382 26.5876L9.08887 27.8754L7.80111 28.2204L7.45606 26.9327Z" fill="#605DBA"/><path d="M15.3333 16.6667H16.6667V18H15.3333V16.6667Z" fill="#605DBA"/><path d="M13.1191 17.1322L14.4069 16.7868L14.7523 18.0749L13.4642 18.4203L13.1191 17.1322Z" fill="#605DBA"/><path d="M11.0892 18.1615L12.2441 17.4948L12.9108 18.6495L11.7562 19.3161L11.0892 18.1615Z" fill="#605DBA"/><path d="M9.40072 19.6765L10.3438 18.7334L11.2865 19.6765L10.3438 20.6192L9.40072 19.6765Z" fill="#605DBA"/><path d="M8.16113 21.5778L8.8278 20.4232L9.98242 21.0899L9.31576 22.2445L8.16113 21.5778Z" fill="#605DBA"/><path d="M8.16081 29.0892L9.31576 28.4226L9.9821 29.5775L8.82748 30.2439L8.16081 29.0892Z" fill="#605DBA"/><path d="M9.40072 30.99L10.3434 30.0473L11.2861 30.99L10.3434 31.933L9.40072 30.99Z" fill="#605DBA"/><path d="M11.0889 32.5059L11.7555 31.3513L12.9102 32.018L12.2438 33.1726L11.0889 32.5059Z" fill="#605DBA"/><path d="M13.1133 33.5326L13.4583 32.2448L14.7461 32.5899L14.401 33.8777L13.1133 33.5326Z" fill="#605DBA"/><path d="M15.3333 32.6667H16.6667V34H15.3333V32.6667Z" fill="#605DBA"/><path d="M17.2637 32.5863L18.5518 32.2409L18.8971 33.529L17.609 33.8744L17.2637 32.5863Z" fill="#605DBA"/><path d="M19.0892 32.0173L20.2438 31.3506L20.9105 32.5053L19.7559 33.1719L19.0892 32.0173Z" fill="#605DBA"/><path d="M20.7135 30.9903L21.6566 30.0476L22.5993 30.9903L21.6566 31.9333L20.7135 30.9903Z" fill="#605DBA"/><path d="M22.0176 29.5778L22.6842 28.4232L23.8389 29.0896L23.1725 30.2445L22.0176 29.5778Z" fill="#605DBA"/><path d="M22.9105 27.875L23.2555 26.5873L24.5436 26.9323L24.1982 28.2201L22.9105 27.875Z" fill="#605DBA"/><path d="M23.3333 24.6667H24.6667V26H23.3333V24.6667Z" fill="#605DBA"/><path d="M22.9108 22.7911L24.1989 22.446L24.5439 23.7338L23.2559 24.0788L22.9108 22.7911Z" fill="#605DBA"/><path d="M22.0176 21.0892L23.1725 20.4229L23.8389 21.5775L22.6842 22.2442L22.0176 21.0892Z" fill="#605DBA"/><path d="M20.7139 19.6768L21.6566 18.7338L22.5996 19.6768L21.6566 20.6195L20.7139 19.6768Z" fill="#605DBA"/><path d="M19.0895 18.6498L19.7559 17.4952L20.9108 18.1615L20.2441 19.3165L19.0895 18.6498Z" fill="#605DBA"/><path d="M17.2542 18.0779L17.5993 16.7898L18.887 17.1351L18.542 18.4229L17.2542 18.0779Z" fill="#605DBA"/></svg>');
              var w = 1 == o.most_popular ? h : "",
                q =
                  7 != o.offer_tab_type
                    ? '<div class="bndl-ic">' + g + "</div>"
                    : "";
              if (
                ((L +=
                  '<div class="special-bonus-bndl-discount active" data-offer_tab_type="' +
                  o.offer_tab_type +
                  '" data-aio-upsell-id="' +
                  i +
                  '">' +
                  c),
                (L +=
                  '<div class="special-bonus-bndl-discount-head"><div class="bndl-contnt"><div class="bndl-contnt-inner">' +
                  w +
                  "<h4>" +
                  o.title +
                  "</h4>" +
                  n +
                  "</div></div>" +
                  q +
                  "</div>"),
                null == p)
              ) {
                p = new Date(
                  csapp_add_time(o.days, o.hours, o.minutes)
                ).getTime();
                csapps.set_local_data(l, p);
              }
              7 != o.offer_tab_type &&
                (csapp_timer(p, i, l, o.days, o.hours, o.minutes),
                (L += '<div class="sb-offer-time">'),
                (L +=
                  '<div class="sb-offer-time-left"><p>' +
                  o.widget_title +
                  "</p></div>"),
                (L +=
                  '<div class="sb-offer-time-right" style="display: none;">'),
                (L += '<div class="sb-offer-time-right-inner">'),
                (L += '<div class="sb-offer-progresser">'),
                (L +=
                  '<div class="sbo-progress days_wrpr"><div class="sbo-progress-inner"><div class="aiod-txt"><div class="aiod-txt-inner"><span class="days_txt">--</span><span class="defination_txt">' +
                  m +
                  '</span></div></div><div class="ppc-progress"><div class="ppc-progress-fill"></div></div></div></div>'),
                (L +=
                  '<div class="sbo-progress hours_wrpr"><div class="sbo-progress-inner"><div class="aiod-txt"><div class="aiod-txt-inner"><span class="hours_txt">--</span><span class="defination_txt">' +
                  C +
                  '</span></div></div><div class="ppc-progress"><div class="ppc-progress-fill"></div></div></div></div>'),
                (L +=
                  '<div class="sbo-progress minutes_wrpr"><div class="sbo-progress-inner"><div class="aiod-txt"><div class="aiod-txt-inner"><span class="minutes_txt">--</span><span class="defination_txt">' +
                  y +
                  '</span></div></div><div class="ppc-progress"><div class="ppc-progress-fill"></div></div></div></div>'),
                (L +=
                  '<div class="sbo-progress seconds_wrpr" style="display: none;"><div class="sbo-progress-inner"><div class="aiod-txt"><div class="aiod-txt-inner"><span class="seconds_txt">--</span><span class="defination_txt">' +
                  x +
                  '</span></div></div><div class="ppc-progress"><div class="ppc-progress-fill"></div></div></div></div>'),
                (L += "</div></div></div></div>")),
                (L += r),
                (L += "</div>");
            }
          }),
            (r += L),
            void 0 !== c.upsell_offer_items.next_page_url &&
              null != c.upsell_offer_items.next_page_url &&
              "" != c.upsell_offer_items.next_page_url &&
              (r +=
                "<div class='upsell_loadmore_wrpr'><button type='button' data-next_url='" +
                window.csapps.vd_url +
                "/api/display-upsell-popup?csapp=aiod&aiodupsell=true&" +
                c.upsell_offer_items.next_page_url.replace("/?", "") +
                "' class='csapp_btn upsell_loadmore'>Load more</button></div>"),
            s(".upsell_loadmore_wrpr").remove(),
            s(".aiod_upsell_aiodp.cs_show").length
              ? s(".special-bonus-aiodp-inner").append(r)
              : ((r += "</div></div>"),
                (r += "</div></div>"),
                s("body").append(r)),
            s(".aiod-special-bonus-aiodp .csapps-bunlde-tiers").each(function (
              s,
              e
            ) {
              count_bundle_wise_price(e);
            }),
            s(".aiod_upsell_opener")
              .removeAttr("disabled", "disabled")
              .removeClass("loading"),
            cart_upsell_opner_loading_stop();
        } else
          s(".aiod_upsell_opener")
            .removeAttr("disabled", "disabled")
            .removeClass("loading"),
            cart_upsell_opner_loading_stop();
      }),
      (window.aiod_upsell_call = function (t, o, a) {
        var i = {
          product_id: window.csapps.product_id,
          shop: window.csapps.store_id,
          collection_ids: window.csapps.product_collections,
          currency: window.csapps.currency_code,
          country: window.csapps.country_code,
        };
        "cart" == window.csapps.page_type && (i.page_type = "2");
        var l = csapps.create_api_url(a, i);
        if (null == window.csapps.all_aiod_api[l])
          window.csapps.upsell_request_ajax = s.ajax({
            type: "GET",
            url: a,
            timeout: e,
            data: i,
            crossDomain: !0,
            dataType: "json",
            beforeSend: function () {
              "ToCancelPrevReq" != window.csapps.upsell_request_ajax &&
                window.csapps.upsell_request_ajax.readyState < 4 &&
                window.csapps.upsell_request_ajax.abort();
            },
            success: function (s) {
              (window.csapps.all_aiod_api[l] = s),
                set_aiod_api_json(l, s),
                aiod_upsell_fill(t, o, a, s);
            },
            error: function (e, t) {
              csapp_checkout_enable(1, !1),
                s(".aiod_upsell_opener")
                  .removeAttr("disabled", "disabled")
                  .removeClass("loading"),
                cart_upsell_opner_loading_stop();
            },
          });
        else {
          var d = window.csapps.all_aiod_api[l];
          aiod_upsell_fill(t, o, a, d);
        }
      }),
      (window.aiod_upsell_reload_ajax = function (e, t) {
        if (window.csapps.cart.items.length > 0) {
          var o = "",
            l = window.csapps.customer,
            d = window.csapps.cart_collections;
          s.getJSON(
            window.csapps.aiod_root_url + "/cart.js?csapp=aiod&aiodupsell=true",
            function (n) {
              s(n.items).each(function (s, e) {
                delete e.product_description;
              }),
                (o =
                  window.csapps.vd_url +
                  "/api/cart-request" +
                  a +
                  "?csapp=aiod&aiodupsell=true");
              var p = {
                cid: l,
                cdata: n,
                cart_collections: d,
                shop: window.csapps.store_id,
                discount_cart_load: !0,
                discount_code: window.csapps.csapp_discount_code,
                currency: window.csapps.currency_code,
                country: window.csapps.country_code,
                lang: window.csapps.aiod_lang_code,
                checkout_access_token: t,
              };
              window.csapps.upsell_fire_cart_ajax = s.ajax({
                url: o,
                timeout: i,
                data: JSON.stringify(p),
                dataType: "json",
                type: "POST",
                contentType: "application/json",
                beforeSend: function () {
                  "ToCancelPrevReq" != window.csapps.upsell_fire_cart_ajax &&
                    window.csapps.upsell_fire_cart_ajax.readyState < 4 &&
                    window.csapps.upsell_fire_cart_ajax.abort();
                },
                success: function (s) {
                  var t = s.applied_offer_ids;
                  aiod_upsell_call(n, t, e);
                },
                error: function (e, t) {
                  console.log("Something went wrong. Please try again!"),
                    s(".aiod_upsell_opener")
                      .removeAttr("disabled", "disabled")
                      .removeClass("loading"),
                    cart_upsell_opner_loading_stop();
                },
              });
            }
          );
        } else
          s.getJSON(
            window.csapps.aiod_root_url + "/cart.js?csapp=aiod&aiodupsell=true",
            function (s) {
              aiod_upsell_call(s, "", e);
            }
          );
      }),
      (window.aiod_upsell_reload = function (t) {
        s(".aiod_upsell_opener")
          .attr("disabled", "disabled")
          .addClass("loading"),
          (window.csapps.upsell_cart_ajax = s.ajax({
            url: o + "&aiodupsell=true",
            timeout: e,
            type: "GET",
            beforeSend: function () {
              "ToCancelPrevReq" != window.csapps.upsell_cart_ajax &&
                window.csapps.upsell_cart_ajax.readyState < 4 &&
                window.csapps.upsell_cart_ajax.abort();
            },
            success: function (e) {
              "function" == typeof csapps.aiod_check_weglot &&
                csapps.aiod_check_weglot();
              e = JSON.parse(e);
              s(
                "<script>" + e.collection + e.cs_cart_count + "</script>"
              ).appendTo(document.body),
                void 0 !==
                  window.csapps.settings.discount.setting
                    .enable_shopify_discount_code &&
                null !=
                  window.csapps.settings.discount.setting
                    .enable_shopify_discount_code &&
                "yes" ==
                  window.csapps.settings.discount.setting
                    .enable_shopify_discount_code &&
                "" != window.csapps.csapp_discount_code
                  ? s.getJSON("/payments/config?csapp=aiod", function (s) {
                      aiod_upsell_reload_ajax(
                        t,
                        s.paymentInstruments.accessToken
                      );
                    })
                  : aiod_upsell_reload_ajax(t, "");
            },
            error: function (e, t) {
              console.log("Something went wrong. Please try again!"),
                s(".aiod_upsell_opener")
                  .removeAttr("disabled", "disabled")
                  .removeClass("loading"),
                cart_upsell_opner_loading_stop();
            },
          }));
      });
  }));
